module.exports = __webpack_public_path__ + "static/media/author-Esme.c748e634.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/author-Esme.png
// module id = 1786
// module chunks = 1